import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import OverrideGeoIPPropertiesIntro from './override-geoip-properties-intro.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <OverrideGeoIPPropertiesIntro mdxType="OverrideGeoIPPropertiesIntro" />
    <p>{`You can override GeoIP properties by including them in the `}<inlineCode parentName="p">{`person_properties`}</inlineCode>{` parameter when evaluating feature flags. This is useful when you're evaluating flags on your backend and want to use the client's location instead of your server's location.`}</p>
    <p>{`The following GeoIP properties can be overridden:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_country_code`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_country_name`}</inlineCode>{` `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_city_name`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_city_confidence`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_continent_code`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_continent_name`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_latitude`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_longitude`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_postal_code`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_subdivision_1_code`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_subdivision_1_name`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_subdivision_2_code`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_subdivision_2_name`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_subdivision_3_code`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_subdivision_3_name`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`$geoip_time_zone`}</inlineCode></li>
    </ul>
    <p>{`Simply include any of these properties in the `}<inlineCode parentName="p">{`person_properties`}</inlineCode>{` parameter alongside your other person properties when calling feature flags. `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      